/* eslint-disable max-len */
import 'react';
const LockSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={13} height={13} xmlns="http://www.w3.org/2000/svg" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h13v13H0z" />
            <g stroke="currentColor" strokeWidth={1.354}>
                <path d="M3.354 5.136h6.292c.748 0 1.354.607 1.354 1.354v3.656c0 .748-.606 1.354-1.354 1.354H3.354A1.354 1.354 0 0 1 2 10.146V6.49c0-.747.606-1.354 1.354-1.354Z" />
                <path
                    d="M4 5.136V3.682C4 2.477 5.186 1.5 6.65 1.5c1.021 0 2.32.744 2.35 2.182.005.221.005.706 0 1.454M6.5 8.773v-.909"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </g>
    </svg>
);
export default LockSvg;
